import React, { useState } from "react";
import ImgSrc from "../../../Assets/common/warning-alert-button.png";
import BlurTableImg from "../../../Assets/common/blur_table.png";
import OverviewTableImg from "../../../Assets/common/overview_table_blur.png";
import BacklinkTableImg from "../../../Assets/common/backlink_table_blur.png";
import GapTableImg from "../../../Assets/common/gap_table_blur.png";
import ReffTableImg from "../../../Assets/common/blur_ref_domain.png";
import GreenCircleTick from "../../../Assets/home/greenCircleTick.gif";
import QuesTableImg from "../../../Assets/common/ques_table_blur.png";
import FallbackLoader from "../FallbackLoader";
import { ZustandStore } from "../../../../store/zustand-store";
import axios from "axios";
import { GET_PAYNOW_LINK } from "../../../../services/constants";
import { useNavigate } from "react-router-dom";

export default function FreeTrialDialog() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isUpgradeShow, setIsUpgradeShow] = useState(false);
  const customer_plan = ZustandStore((state) => state.customer_plan);
  const tableBlurImg = sessionStorage.getItem("FREE_TRIAL_TABLE");
  const blurImg = {
    keywordTable: BlurTableImg,
    overviewTable: OverviewTableImg,
    backlinkTable: BacklinkTableImg,
    reffDomainTable: ReffTableImg,
    quesKeywordTable: QuesTableImg,
    gapTable: GapTableImg,
  };
  const blurImgSrc = blurImg[tableBlurImg] || BlurTableImg; // fallback to default

  const handleMailClick = async () => {
    setLoading(true);
    const email = localStorage.getItem("admin_mail");
    const getLink = await axios.post(GET_PAYNOW_LINK(email));
    setLoading(false);
    setIsUpgradeShow(false);
    getLink.data.portal_url && window.open(getLink.data.portal_url, "_blank");
  };

  const toggleShowUpgradePopup = (show) => {
    if (customer_plan?.status === "trialing") {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setIsUpgradeShow(show);
      }, 300);
    } else {
      navigate("/upgrade");
    }
  };

  return (
    <React.Fragment>
      <img src={blurImgSrc} alt="data-table" className="w-100 h-100" />
      <div
        className="w-100"
        style={{
          position: "absolute",
          top: "10%",
          margin: "auto",
        }}
      >
        <div
          className="pllogin-div"
          style={{
            minHeight: "340px",
            height: "340px",
            maxWidth: "540px",
            width: "540px",
            margin: "auto",
          }}
        >
          <div className="add-new-project flex-column align-items-center p-4 w-100 h-100">
            {loading ? (
              <FallbackLoader />
            ) : (
              <>
                <div className="project-img" style={{ minHeight: "140px" }}>
                  <img
                    src={isUpgradeShow ? GreenCircleTick : ImgSrc}
                    alt=""
                    key={isUpgradeShow ? "upgrade" : "alert"}
                    style={{ maxWidth: "140px" }}
                  />
                </div>
                <div className="pl-con flex-column p-0">
                  <h2 className="heading-large w-75 font-light-bold">
                    {isUpgradeShow
                      ? "Upgrade Plan"
                      : "You are on Free Trial now."}
                  </h2>
                  {isUpgradeShow ? (
                    <>
                      <p className="heading-medium mb-0">
                        You’re about to upgrade to the{" "}
                        <b>{customer_plan.plan_name} Plan</b> and unlock full
                        access to your data and features.
                      </p>
                      <p className="heading-medium">
                        Your saved card will be charged immediately.
                      </p>
                    </>
                  ) : (
                    <p className="heading-medium">
                      Pay now to unlock all features and maximize your
                      experience!
                    </p>
                  )}
                  {isUpgradeShow ? (
                    <div className="d-flex align-items-center w-100">
                      <button
                        className="trail-upgrade-plan-btn w-50"
                        style={{
                          backgroundColor: "white",
                          color: "#131927",
                          borderColor: "#00000033",
                        }}
                        onClick={() => toggleShowUpgradePopup(false)}
                      >
                        Cancel
                      </button>
                      <button
                        className="trail-upgrade-plan-btn ms-2 w-50"
                        onClick={handleMailClick}
                      >
                        Confirm & Pay Now
                      </button>
                    </div>
                  ) : (
                    <button
                      className="trail-upgrade-plan-btn"
                      onClick={() => toggleShowUpgradePopup(true)}
                    >
                      {customer_plan?.status === "Free" ? "Upgrade" : "Pay Now"}
                      <svg
                        className="ms-2"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="#6a3be4"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="12" cy="12" r="12" fill="#6a3be4" />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.135 7.52148C10.8477 7.25108 10.8341 6.79903 11.1045 6.51179C11.3749 6.22455 11.8269 6.21091 12.1142 6.48131L17.2822 11.3465C17.5346 11.4567 17.7109 11.7084 17.7109 12.0014C17.7109 12.294 17.5351 12.5454 17.2833 12.6559L12.1142 17.522C11.8269 17.7924 11.3749 17.7788 11.1045 17.4915C10.8341 17.2043 10.8477 16.7523 11.135 16.4819L15.1356 12.7157H6.99611C6.60162 12.7157 6.28182 12.3959 6.28182 12.0014C6.28182 11.6069 6.60162 11.2871 6.99611 11.2871H15.135L11.135 7.52148Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
